require("./brokerConvenienceTestSuccess.scss");

// @vendors
const React = require("react");
const PropTypes = require("prop-types");

// @utilities
const { isPrivateEquityTest } = require('mifid/utilities/mifidPrivateEquityHelper');

// @components
const BrokerConvenienceConfirmationSuccess = require("./brokerConvenienceConfirmationSuccess/brokerConvenienceConfirmationSuccess");
const BrokerConvenienceTestConfirmation = require("./brokerConvenienceTestConfirmation/brokerTestConvenienceConfirmation");
const BrokerConvenienceConfirmationAltFundsSuccess = require("./brokerConvenienceConfirmationAltFundsSuccess/brokerConvenienceConfirmationAltFundsSuccess");

class BrokerConvenienceTestSuccess extends React.Component {
    constructor(props) {
        super(props);
    }

    buildConfirmation() {
        return this.props.confirmationStatus === "" ? (
            <BrokerConvenienceTestConfirmation
                onTestResultsConfirm={this.props.onTestResultsConfirm}
                immBrokerConvenienceMiFIDTest={this.props.immBrokerConvenienceMiFIDTest}
                goToFirstStep={this.props.goToFirstStep}
                getCurrentTestScore={this.props.getCurrentTestScore}
                flagBasedFeatures={this.props.flagBasedFeatures}
                history={this.props.history}
                immProfileFields={this.props.immProfileFields}
            />
        ) : null;
    }
    buildConfirmationSuccess() {
        const { immBrokerConvenienceMiFIDTest, goToFinishTest, history } = this.props;
        const testToEvaluateId = immBrokerConvenienceMiFIDTest.getIn(['mifidv2','testToEvaluate', 'tipoTest'])
        const ConfirmacionComponent = isPrivateEquityTest(testToEvaluateId) 
            ? BrokerConvenienceConfirmationAltFundsSuccess 
            : BrokerConvenienceConfirmationSuccess;
        return this.props.confirmationStatus === "success" ? (
            
            <ConfirmacionComponent
                goToFinishTest={goToFinishTest}
                immBrokerConvenienceMiFIDTest={immBrokerConvenienceMiFIDTest}
                history={history}
            />
        ) : null;
    }

    render() {
        return (
            <section className="broker-convenience-test-success">
                {this.buildConfirmation()}
                {this.buildConfirmationSuccess()}
            </section>
        );
    }
}

BrokerConvenienceTestSuccess.propTypes = {
    confirmationStatus: PropTypes.oneOf[("success", "fail")],
    onTestResultsConfirm: PropTypes.func,
    goToFinishTest: PropTypes.func,
    getCurrentTestScore: PropTypes.func,
    goToFirstStep: PropTypes.func,
    immBrokerConvenienceMiFIDTest: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
    history: PropTypes.object,
    immProfileFields: PropTypes.object,
};

BrokerConvenienceTestSuccess.defaultProps = {
    confirmationStatus: "",
};

module.exports = BrokerConvenienceTestSuccess;
